import Core from 'core/js/components/layout-menu/_session-menu.js'
export default Vue.extend({
  extends: Core,
  name: 'session-menu-custom-gc',
  data() {
    return {
      municipalityMenuItems: [
        {
          id: 'balance',
          routeName: 'data-balance',
          icon: 'coins'
        },
        {
          id: 'payment-medias',
          routeName: 'data-payment-medias',
          icon: 'wallet'
        },
        {
          id: 'travels',
          routeName: 'data-travels',
          icon: 'ticket'
        }
      ]
    }
  }
})
